import React, { FC } from 'react'
import { Button, Tooltip, Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { TTableColumn } from 'shared/types'
import { UsersTableProps } from './UsersTable.props'
import { IUsersTableData } from '../../types'

import './UsersTable.scss'

const UsersTable: FC<UsersTableProps> = ({ usersList, onUpdateUser }) => {
  const columns: ColumnsType<TTableColumn>[] = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'Name',
      sortable: false,
      align: 'left'
    },
    {
      dataIndex: 'email',
      key: 'email',
      title: 'Email',
      sortable: false,
      align: 'left',
      render: (value: string) => (
        <a href={`mailto:${value}`} className="users-table__email">
          {value}
        </a>
      )
    },
    {
      dataIndex: 'label',
      key: 'label',
      title: 'Zone / Spaces',
      sortable: false,
      align: 'left'
    },
    {
      dataIndex: 'role',
      key: 'role',
      title: 'Roles',
      sortable: false,
      align: 'left'
    },
    {
      dataIndex: '',
      key: 'edit',
      title: 'Edit',
      sortable: false,
      align: 'right',
      render: (value: string, user: any) => (
        <Tooltip message="Edit User" colorType="dark">
          <Button
            className="users-table__edit"
            onClick={onUpdateUser(user.editLink)}
            icon="pen-to-square"
            colorType="secondary-black"
            containerStyle="link"
          />
        </Tooltip>
      )
    }
  ]

  return (
    <Table
      className="users-table"
      rowKey={(record: IUsersTableData) => record.id}
      columns={columns as any}
      data={usersList}
      pagination={false}
    />
  )
}

export default UsersTable
